import { render, staticRenderFns } from "./medicRoute.vue?vue&type=template&id=50e30d45"
import script from "./medicRoute.vue?vue&type=script&lang=js"
export * from "./medicRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports